/**
 * progress theme
 * @see https://github.com/chakra-ui/chakra-ui/blob/%40chakra-ui/react%403.0.0/packages/react/src/theme/recipes/progress.ts
 */
import { defineSlotRecipe } from '@chakra-ui/react';
import { progressAnatomy } from '@chakra-ui/react/anatomy';
export const progress = defineSlotRecipe({
    slots: progressAnatomy.keys(),
    base: {},
    variants: {
        variant: {
            outline: {
                track: {
                    boxShadow: 'inset 0 0 0 1px {colors.state.success}',
                    bgColor: '#BAFFD9',
                },
                range: {
                    bgColor: 'state.success',
                },
            },
        },
        size: {
            md: {
                track: {
                    h: '6px',
                },
                range: {},
            },
        },
        shape: {
            full: {},
        },
    },
    compoundVariants: [],
    defaultVariants: {
        shape: 'full',
        size: 'md',
        variant: 'outline',
    },
});
